import React, { useEffect, useRef } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Typography, IconButton } from '@mui/material';
import { Spinner } from '../index';
import './DataSection.sass';

export default function DataSection({
  children,
  className,
  id,
  isActive,
  loading = false,
  setQuickMenuAnchor,
  title,
  secondaryAction,
  style = {},
  ...rest
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (isActive && ref?.current) {
      setQuickMenuAnchor(null);
      ref.current.scrollIntoView();
    }
  }, [isActive, ref]);

  return (
    <section
      ref={ref}
      id={id}
      className={`data-section ${className || ''}`}
      style={style}
      {...rest}
    >
      {title && (
        <Box
          bgcolor="background.default"
          color="text.secondary"
          className="data-section-header"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          <Box
            onClick={event => {
              setQuickMenuAnchor(event.target);
            }}
            display="flex"
            flexDirection="row"
            alignItems="center"
          >
            <Typography
              style={{
                cursor: 'pointer'
              }}
              variant="body2"
            >
              <strong>{title}</strong>
            </Typography>
            <IconButton
              className="quick-menu-chevron"
              component="span"
              size="small"
            >
              <ExpandMoreIcon />
            </IconButton>
          </Box>
          {secondaryAction}
        </Box>
      )}
      <div
        style={{
          height: ['wind_speed', 'temperature', 'load_curve'].includes(id)
            ? 280
            : '100%'
        }}
        className="data-section-content"
      >
        {loading ? <Spinner /> : children}
      </div>
    </section>
  );
}
